export const mapListType = {
    'ul': 'unorderedList',
    'ol': 'orderedList'
};

export const testAttributes = {
    LIST_CONTAINER: 'list-container',
}
